<template>
<ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-md">
  <li :class="{ 'page-item': true, 'disabled': currentPage == 1 }">
    <span aria-hidden="true" @click="pageChanged(currentPage-1)" aria-label="Previous" class="page-link">{{prevText}}</span>
  </li>
  <li v-for="n in paginationRange" :class="{ 'page-item': true, 'active': activePage(n) }">
    <a href="#" @click.prevent="pageChanged(n)" tabindex="0" aria-checked="true" target="_self" class="page-link">{{ n }}</a>
  </li>
  <li :class="{ 'page-item': true, 'disabled': currentPage == totalPages }">
    <span aria-hidden="true" @click="pageChanged(currentPage+1)" aria-label="Next" class="page-link">{{nextText}}</span>
  </li>
</ul>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: Number,
    itemsPerPage: Number,
    totalItems: Number,
    visiblePages: {
      type: Number,
      default: 5,
      coerce: (val) => parseInt(val)
    },
    prevText: String,
    nextText: String
  },
  computed: {
    lastPage() {
      if (this.totalPages) {
        return this.totalPages
      } else {
        return this.totalItems % this.itemsPerPage === 0
          ? this.totalItems / this.itemsPerPage
          : Math.floor(this.totalItems / this.itemsPerPage) + 1
      }
    },
    paginationRange() {
      let start =
        this.currentPage - this.visiblePages / 2 <= 0
        ? 1 : this.currentPage + this.visiblePages / 2 > this.lastPage
        ? this.lowerBound(this.lastPage - this.visiblePages + 1, 1)
        : Math.ceil(this.currentPage - this.visiblePages / 2)

      let range = []

      for (let i = 0; i < this.visiblePages && i < this.lastPage; i++) {
        range.push(start + i)
      }

      return range
    }
  },
  methods: {
    lowerBound(num, limit) {
      return num >= limit ? num : limit
    },
    activePage(pageNum) {
      return this.currentPage === pageNum ? 'active' : ''
    },
    pageChanged(pageNum) {
      this.$emit('page-changed', pageNum)
    }
  }
}
</script>